import { Button } from '@noorden-insurtech/alba-design-system';
import type { BulkRunState } from '../hooks/use-bulk-broker-products.hook';

interface BulkProductsProgressProps {
  state: BulkRunState;
  onCancel: () => void;
}

export function BulkProductsProgress({
  state,
  onCancel,
}: BulkProductsProgressProps) {
  const percent =
    state.total === 0 ? 0 : Math.round((state.done / state.total) * 100);

  const isCancelling = state.status === 'cancelling';

  return (
    <div className='flex flex-col gap-4 py-8'>
      <div className='flex flex-col gap-2'>
        <p className='text-base font-bold text-alba-black-500'>
          {isCancelling ? 'Cancelando…' : 'Aplicando…'}
        </p>

        {/* O design system não tem barra de progresso; esta é a mesma do
            widget de importação de vidas. */}
        <div
          role='progressbar'
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
          className='h-1.5 w-full overflow-hidden rounded-full bg-alba-gray-200'
        >
          <div
            className='h-full rounded-full bg-alba-blue-500 transition-[width] duration-500 ease-out'
            style={{ width: `${percent}%` }}
          />
        </div>

        <p className='text-sm text-alba-gray-700'>
          {state.done} de {state.total} corretoras
          {state.totals.failed > 0 && ` · ${state.totals.failed} com erro`}
        </p>
      </div>

      <p className='text-sm text-alba-gray-600'>
        {isCancelling
          ? 'Aguardando o lote em andamento terminar. O que já foi enviado não é desfeito.'
          : 'Não feche esta janela. Cancelar interrompe os lotes que ainda não foram enviados — os já enviados terminam.'}
      </p>

      <div className='flex justify-stretch sm:justify-end'>
        <Button
          variant='outline'
          onClick={onCancel}
          disabled={isCancelling}
          className='w-full sm:w-auto'
        >
          Cancelar execução
        </Button>
      </div>
    </div>
  );
}
